import { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import {
  PayAccessControl,
  PayAuthorizations,
} from '../authorizations/PayAccessControl';
import { useIsAggregator } from '../../hooks/useIsAggregator';
const BusinessSettings = lazy(() => import('./BusinessSettings'));
const CollectMethodsSettings = lazy(
  () => import('../collectMethods/CollectMethodsSettings')
);
const IntegrationsSettings = lazy(() => import('./IntegrationsSettings'));
const NotificationsSettings = lazy(() => import('./NotificationsSettings'));
const CustomerNotificationsSettings = lazy(
  () => import('./CustomerNotificationsSettings')
);

export function SettingsScreen(): JSX.Element {
  const isAggregator = useIsAggregator();
  const isLegacyAccount = !isAggregator;
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PayAccessControl allowed={PayAuthorizations.manageBusiness}>
          <BusinessSettings />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/collect-methods`}>
        <PayAccessControl allowed={PayAuthorizations.viewCollectMethods}>
          <CollectMethodsSettings />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/integrations`}>
        <PayAccessControl allowed={PayAuthorizations.viewIntegrations}>
          <IntegrationsSettings />
        </PayAccessControl>
      </Route>
      {isLegacyAccount && (
        <>
          <Route exact path={`${path}/notifications`}>
            <PayAccessControl allowed={PayAuthorizations.manageNotifications}>
              <NotificationsSettings />
            </PayAccessControl>
          </Route>
          <Route exact path={`${path}/customer-notifications`}>
            <PayAccessControl allowed={PayAuthorizations.manageNotifications}>
              <CustomerNotificationsSettings />
            </PayAccessControl>
          </Route>
        </>
      )}
    </Switch>
  );
}
